export default __webpack_public_path__ + "static/sesame_logo-8a9ca205ed269e6d874598ddea73a560.webp";